import axios from 'axios';
import * as urls from 'constants/urls';

export const getDistributors = () => axios.get(urls.DISTRIBUTORS.stringify())

export const getCities = () => axios.get(urls.CITIES.stringify())


// WEBPACK FOOTER //
// ./src/actions/httpHandlers/handlers.js